import Vue from 'vue'
import store from './store'

const can = permission => {
  const config = store.state.authConfig || {}
  const permissions = config.permissions || []

  return permissions.includes(permission)
}

// TODO check if the directive can be made reactive, while it doesn't work :(.
Vue.directive('can', {
  bind: function (el, binding, vnode) {
    const permission = binding.expression
      .replace(/'/g, '')
      .replace(/"/g, '')

    if (!can(permission)) {
      vnode.elm.style.display = 'none'
    }
  }
})

Vue.prototype.$can = can

Vue.prototype.$hasRole = roles => {
  const config = store.state.authConfig || {}
  const userRoles = config.roles || {}

  if (!Array.isArray(roles)) {
    if (roles.includes('|')) {
      roles = roles.split('|')
    } else {
      roles = [roles]
    }
  }

  return roles.some(role => userRoles.includes(role))
}
